import styled from 'styled-components';
import { ProducerLogo } from '../../components/icons/producer-logo';

export const MaintenanceRoute = () => (
  <Container>
    <ProducerLogo />
    <h1>Sorry, PRODUCER is down for scheduled maintenance.</h1>
    <p>We've got something special in store for you and we can't wait for you to see it.</p>
    <p>
      Check our{' '}
      <a href="https://the-producer.statuspage.io/" target="_blank">
        status page
      </a>{' '}
      for live updates.
    </p>
  </Container>
);

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: center;
  width: 100%;
  padding-bottom: 1.6rem;

  h1 {
    margin-top: 3.2rem;
    margin-bottom: 1.6rem;
  }

  p {
    line-height: 2.4rem;
  }
`;
